import { Component } from '@angular/core';

@Component({
  selector: 'tt-certificate-requirements-view',
  templateUrl: './certificate-requirements-view.component.html',
  styleUrls: ['./certificate-requirements-view.component.css']
})
export class CertificateRequirementsViewComponent {

}
